import { createPlayListAyahTemplate } from '../../../views/templates/template-creator';

const PlayHandler = {
  init(surah, btnPlayAyah) {
    const reader = {
      alafasy: "Misyari Rasyid Al-'Afasi",
      ahmedajamy: 'Ahmed Al Ajmi',
      husarymujawwad: 'Mahmoud Khalil Al-Hussary',
      minshawi: 'Muhammad Saddiq Al-Minshawi',
      muhammadayyoub: 'Muhammad Ayyub',
      muhammadjibreel: 'Muhammad Al Said Hussayn Jibreel',
    };
    this._playListener({
      surah, btnPlayAyah, reader,
    });
  },

  _playListener({
    surah, btnPlayAyah, reader,
  }) {
    btnPlayAyah.forEach((btn) => {
      const numAyahQuran = btn.getAttribute('numAyahQuran');
      const numAyahSurah = btn.getAttribute('numAyahSurah');
      const playListContainer = document.querySelector(`#play-list-${numAyahQuran}`);
      const { audio } = surah.data.ayahs[numAyahSurah - 1];
      btn.addEventListener('click', () => this._showPlaylist({
        btn, reader, playListContainer, audio,
      }));
    });
  },

  _showPlaylist({
    btn, reader, playListContainer, audio,
  }) {
    playListContainer.classList.toggle('hidden');
    btn.classList.toggle('border-b');
    if (!playListContainer.classList.contains('hidden')) {
      this._insertPlaylist({
        reader, playListContainer, audio,
      });
      playListContainer.firstElementChild.setAttribute('open', '');
    } else {
      playListContainer.innerHTML = '';
    }
  },

  _insertPlaylist({
    reader, playListContainer, audio,
  }) {
    Object.keys(audio).forEach((key) => {
      playListContainer.innerHTML += createPlayListAyahTemplate(reader[key], audio[key]);
    });
  },
};

export default PlayHandler;
